import { useState, useCallback, useEffect } from 'react';
import StoreWebservice from '../webservices/StoreWebservice';
import PaymentMethodsContext, { isPaymentMethodsItem } from '../context/PaymentMethods';

const { NotificationManager } = require('@paymongo/seeds');

const storeWebservice = new StoreWebservice();

const PaymentMethodsProvider = (props: any) => {
  const id: string = new URLSearchParams(document.location.search).get('store_id') || '';
  const sessionToken: string = new URLSearchParams(document.location.search).get('session_token') || '';

  const [data, setData] = useState(new Array<isPaymentMethodsItem>());
  const [isLoading, setIsLoading] = useState(false);
  const [isButtonLoading, setIsButtonLoading] = useState(false);
  const [isChanged, setIsChanged] = useState(false);
  const [noSelectedPaymentMethod, setNoSelectedPaymentMethod] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);

  const getAllowedPaymentMethods = useCallback(() => {
    return data.filter(item => item.allowed).map(item => item.payment_method)
  }, [data]);

  const getConfiguredPaymentMethods = useCallback(() => {
    return data.filter(item => item.configured).map(item => item.payment_method)
  }, [data]);

  // Update noSelectedPaymentMethod
  useEffect(() => {
    const allowed = getAllowedPaymentMethods();
    const configured = getConfiguredPaymentMethods();

    setNoSelectedPaymentMethod(!allowed.some((element) => configured.includes(element)));
  }, [data, setNoSelectedPaymentMethod, getAllowedPaymentMethods, getConfiguredPaymentMethods])

  const setValue = (paymentMethod: string, value: Boolean) => {
    setData(data => data.map(
      item => item.payment_method === paymentMethod ? {...item, allowed: value}: item)
    )
    setIsChanged(true);
  }

  const loadPaymentMethods = async () => {
    setIsLoading(true);

    await storeWebservice.getPaymentMethods(id, sessionToken)
      .then(function (response) {
        setData(response.data);
      })
      .catch(function (error) {})

    setIsLoading(false);
  }

  const savePaymentMethods = async () => {
    setIsButtonLoading(true);

    await storeWebservice.savePaymentMethods(id, sessionToken, getAllowedPaymentMethods())
      .then(function (response) {
        setData(response.data);
        setIsSuccess(true);
        setIsChanged(false);
      })
      .catch(() => {
        NotificationManager.push('error', <div>Something went wrong. Please refresh the page to try again.</div>);
      })

    setIsButtonLoading(false);
  }

  const paymentMethodsData = { 
    data,
    isButtonLoading,
    isChanged,
    isLoading,
    isSuccess,
    loadPaymentMethods,
    noSelectedPaymentMethod,
    savePaymentMethods,
    setValue
  };

  return <PaymentMethodsContext.Provider value={paymentMethodsData} {...props} />;
}


export default PaymentMethodsProvider;
